import { useContext, useEffect, useState } from 'react'

import { Skeleton, Typography } from '@mui/material'

import { AppContext } from '/providers/app-context'
import { PassContext } from "/components/editor/pass-context"
import { getTemplateData } from '/providers/templates-api'

import AppleFront from "/components/editor/apple/front"
import AppleBack from "/components/editor/apple/back"
import GoogleFront from "/components/editor/google/front"
import GoogleBack from "/components/editor/google/back"

const TemplatePreview = ({ template }) => {

  const { apiSource, apiKey, client } = useContext(AppContext)

  const templateId = template.template_id
  const [templateData, setTemplateData] = useState(null)

  useEffect(() => {
    (async () => {
      const td = await getTemplateData({ apiSource, apiKey, templateId })
      setTemplateData(td.template)
    })()
  }, [templateId])

  if (!template || !templateData) return (
    <div className='flex flex-col preview scaled mt-3 -mr-20'>
      <div className={"flex flex-row gap-5 preview mt-5"}>
        <Skeleton variant="rectangular" width={375} height={500} />
        <Skeleton variant="rectangular" width={375} height={500} />
      </div>
      <div className={"flex flex-row gap-5 preview mt-5"}>
        <Skeleton variant="rectangular" width={375} height={500} />
        <Skeleton variant="rectangular" width={375} height={500} />
      </div>
    </div>
  )

  return (
    <div className='flex flex-col justify-start gap-5 preview -mr-20 mt-3 min-w-[680px] pb-10'>

      <div className={"flex flex-row gap-5"}>
        <div className='flex flex-col gap-5'>
          <Typography variant='h4'>Apple</Typography>

          <div className="apple scaled">
            <div className="wrapper"> {/* Put apple pass on a grey background with drop shadow */}
              <div className="pass" id="appleFront"> {/* id="appleFront" required for the image grab for the minature at the top of the back fields*/}
                <PassContext.Provider value={{ device: "apple", preview: true, clientId: client?.id, templateId: template.template_id, smartixPassType: template.pass_type_id, showEditableFields: false, model: templateData.apple_model, template: templateData.apple_template, variables: templateData.variables, passType: templateData.apple_pass_type, subType: templateData.apple_sub_type }}>
                  <AppleFront />
                </PassContext.Provider>
              </div>
            </div>
          </div>
        </div>

        <div className='flex flex-col gap-5'>
          <Typography variant='h4'>Google</Typography>

          <div className="google scaled">
            <div className="wrapper"> {/* Put apple pass on a grey background with drop shadow */}
              <div className="pass">
                <PassContext.Provider value={{ device: "google", preview: true, clientId: client?.id, templateId: template.template_id, smartixPassType: template.pass_type_id, showEditableFields: false, classData: templateData.google_class, objectData: templateData.google_object, variables: templateData.variables, passType: templateData.google_pass_type, subType: templateData.google_sub_type }}>
                  <GoogleFront showStandardPassItems={false} />
                </PassContext.Provider>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={"flex flex-row gap-5"}>
        <div className="apple scaled">
          <div className="wrapper"> {/* Put apple pass on a grey background with drop shadow */}
            <div className="pass"> {/* id="appleFront" required for the image grab for the minature at the top of the back fields*/}
              <PassContext.Provider value={{ device: "apple", preview: true, clientId: client?.id, templateId: template.template_id, smartixPassType: template.pass_type_id, showEditableFields: false, model: templateData.apple_model, template: templateData.apple_template, variables: templateData.variables, passType: templateData.apple_pass_type, subType: templateData.apple_sub_type }}>
                <AppleBack />
              </PassContext.Provider>
            </div>
          </div>
        </div>

        <div className="google scaled">
          <div className="wrapper"> {/* Put apple pass on a grey background with drop shadow */}
            <div className="pass">
              <PassContext.Provider value={{ device: "google", preview: true, clientId: client?.id, templateId: template.template_id, smartixPassType: template.pass_type_id, showEditableFields: false, classData: templateData.google_class, objectData: templateData.google_object, variables: templateData.variables, passType: templateData.google_pass_type, subType: templateData.google_sub_type }}>
                <GoogleBack showStandardPassItems={false} />
              </PassContext.Provider>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TemplatePreview